import MascotasTable from "./mascotas-table";

export default MascotasTable;
